module.exports = __webpack_public_path__ + "img/facility1-.12c8efb1.jpeg";